<template>
  <div class="login" @keydown.enter="handleSubmit">
    <div class="login-con">
      <Card :bordered="false">
        <p slot="title">
          <Icon type="log-in"></Icon>
          欢迎登录
        </p>
        <div class="form-con">
          <Form ref="loginForm" :model="form" :rules="rules">
            <FormItem prop="userName">
              <Input v-model="form.userName" placeholder="请输入用户名">
              <span slot="prepend">
                                    <Icon :size="16" type="person"></Icon>
                                </span>
              </Input>
            </FormItem>
            <FormItem prop="password">
              <Input type="password" v-model="form.password" placeholder="请输入密码">
              <span slot="prepend">
                                    <Icon :size="14" type="locked"></Icon>
                                </span>
              </Input>
            </FormItem>

            <FormItem>
              <Button type="primary" :loading="loading" @click="handleSubmit" long>
                <span v-if="!loading">登录</span>
                <span v-else>登录中...</span>
              </Button>

            </FormItem>
          </Form>
        </div>
      </Card>
    </div>
  </div>
</template>
<script>
  import {Card, Form, FormItem, Button, Icon, Input} from 'iview'

  export default {
    components: {Card, Form, FormItem, Button, Icon, Input},
    data() {
      return {
        form: {
          userName: process.env.NODE_ENV === 'development' ? 'lwx' : '',
          password: process.env.NODE_ENV === 'development' ? 'hzdw400' : '',
//          userName: '',
//          password: '',
        },
        loading: false,
        rules: {
          userName: [
            {required: true, message: '账号不能为空', trigger: 'blur'}
          ],
          password: [
            {required: true, message: '密码不能为空', trigger: 'blur'}
          ]
        }
      }
    },
    methods: {
      handleSubmit() {
        this.$refs.loginForm.validate((valid) => {
          if (valid) {
            this.loading = true
            this.ajax.fetch({
              url: this.apis.public.login,
              disableLoading: true,
              method: 'post',
              param: {
                accountName: this.form.userName,
                password: this.form.password
              },
              successFunc: response => {
                const access = response.access ? JSON.parse(response.access) : '';
                this.toast.showSuccess("登录成功");
                const routerParam = {
                  router: 'noJurisdiction',
                  type: 'noJurisdiction'
                };
                if (response.user.adminType === 10) {
                  try {
                    this.cache.storeMenuItems(this.menu.menu);
                  }catch (e) {
                    console.log(e)
                  }

                  routerParam.router = 'goodslist';
                } else if(response.user.adminType === 30){
                  try {
                    this.cache.storeMenuItems(this.xyMenu.menu);
                  }catch (e) {
                    console.log(e)
                  }
                  routerParam.router = 'productList';
                }else {
                  routerParam.router = 'serviceordermanage';
                  this.cache.storeMenuItems(this.comMenu.menu);
                }
                this.cache.storeSystemMenuItems(access ? access.data : '');
//                this.cache.storeSystemJurisdiction(response.jurisdiction);

                this.cache.storeOssPath(response.ossUrl);
                this.cache.storeUserInfo(response.user);
                // 初始化oss信息
                this.apis.public.oss.initOssConfig();
                // 权限代码暂时注释
//                if (response.jurisdiction === '10') {
//                  routerParam.router = 'goodslist'
//                } else {
//                  if (access && access.data) {
//                    const temp = this.menu.menu;
//                    gotoBreak:
//                      for (let i = 0, len = temp.length; i < len; i++) {
//                        if (temp[i].name === 'system_manage') continue;
//                        if (temp[i].subMenus.length > 0) {
//                          for (let j = 0, jlen = temp[i].subMenus.length; j < jlen; j++) {
//                            if (access.manage.indexOf(temp[i].subMenus[j].menuKey) > -1) {
//                              routerParam.router = temp[i].subMenus[j].menuKey;
//                              routerParam.type = temp[i].subMenus[j].menuKey;
//                              break gotoBreak;
//                            }
//                          }
//                        } else {
//                          if (access.manage.indexOf(temp[i].name) > -1) {
//                            routerParam.router = temp[i].menuKey;
//                            routerParam.type = temp[i].name;
//                            break;
//                          }
//                        }
//                      }
//                  }
//                }
                this.$router.replace({name: routerParam.router});
                this.$store.commit('changeKey', routerParam.router)
              },
              errorFunc: error => {
                this.loading = false;
                if (error.info) {
                  this.toast.showWarning(error.info)
                }
              },
              errorGoOnFunc: error => {
                this.loading = false;
              }
            })
          }
        })
      }
    }
  }
</script>
<style type="text/scss" lang="scss" scoped>

  .login {
    width: 100%;
    height: 100%;
    background-color: #bdbcbc;
    background-image: url('../../assets/img/bg_login.jpg');
    background-size: cover;
    background-position: center;
    position: relative;
  }

  .login-con {
    position: absolute;
    right: 160px;
    top: 50%;
    transform: translateY(-60%);
    width: 300px;
  }

  .login-header {
    font-size: 16px;
    font-weight: 300;
    text-align: center;
    padding: 30px 0;
  }

  .form-con {
    padding: 10px 0 0;
  }

  .login-tip {
    font-size: 10px;
    text-align: center;
    color: #c3c3c3;
  }

</style>




// WEBPACK FOOTER //
// src/page/login/login.vue